import { useRef } from 'react'
import { useInView } from 'framer-motion'
import { useAnimatedCounter } from '../../hooks/useAnimatedCounter'

interface AnimatedCounterProps {
  value: number
  suffix?: string
  prefix?: string
  duration?: number
  className?: string
}

export function AnimatedCounter({ value, suffix = '', prefix = '', duration = 2000, className }: AnimatedCounterProps) {
  const ref = useRef<HTMLSpanElement>(null)
  const isInView = useInView(ref, { once: true, margin: '-80px' })
  const count = useAnimatedCounter(value, isInView, duration)

  return (
    <span ref={ref} className={className} aria-label={`${prefix}${value}${suffix}`}>
      {prefix}{count}{suffix}
    </span>
  )
}
